export { default } from './RegisterCompany';
